import { cn } from 'utils/StyleUtils'

export const ContractsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M240-80q-50 0-85-35t-35-85v-40q0-33 23.5-56.5T200-320h40v-480q0-33 23.5-56.5T320-880h440q33 0 56.5 23.5T840-800v600q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-600H320v480h280q33 0 56.5 23.5T680-240v40q0 17 11.5 28.5T720-160ZM400-600q-17 0-28.5-11.5T360-640q0-17 11.5-28.5T400-680h280q17 0 28.5 11.5T720-640q0 17-11.5 28.5T680-600H400Zm0 120q-17 0-28.5-11.5T360-520q0-17 11.5-28.5T400-560h280q17 0 28.5 11.5T720-520q0 17-11.5 28.5T680-480H400ZM240-160h360v-80H200v40q0 17 11.5 28.5T240-160Zm0 0h-40 400-360Z" />
  </svg>
)

export const MeterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M360-122v-60q-106-37-173-129.5T120-522q0-75 28.5-140.5t77-114q48.5-48.5 114-77T479-882q74 0 140 28.5t115 77q49 48.5 77.5 114T840-522q0 118-67.5 209.5T600-183v61q0 17-11.5 28.5T560-82q-17 0-28.5-11.5T520-122v-42q-10 2-20 2h-21q-10 0-19.5-.5T440-164v42q0 17-11.5 28.5T400-82q-17 0-28.5-11.5T360-122Zm120-118q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82ZM360-600h240q17 0 28.5-11.5T640-640q0-17-11.5-28.5T600-680H360q-17 0-28.5 11.5T320-640q0 17 11.5 28.5T360-600Zm80 210-20 20q-13 13-13 30t13 30q13 13 30 13t30-13l62-62q12-12 12-28t-12-28l-22-22 20-20q13-13 13-30t-13-30q-13-13-30-13t-30 13l-62 62q-12 12-12 28t12 28l22 22Zm40-130Z" />
  </svg>
)

export const PrivacyIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="currentColor"
      height="16"
      viewBox="0 -960 960 960"
      width="16"
    >
      <path d="M420-360h120l-23-129q20-10 31.5-29t11.5-42q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 23 11.5 42t31.5 29l-23 129Zm60 280q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm0-316Z" />
    </svg>
  )
}

export const DocumentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M360-240h240q17 0 28.5-11.5T640-280q0-17-11.5-28.5T600-320H360q-17 0-28.5 11.5T320-280q0 17 11.5 28.5T360-240Zm0-160h240q17 0 28.5-11.5T640-440q0-17-11.5-28.5T600-480H360q-17 0-28.5 11.5T320-440q0 17 11.5 28.5T360-400ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h287q16 0 30.5 6t25.5 17l194 194q11 11 17 25.5t6 30.5v447q0 33-23.5 56.5T720-80H240Zm280-560v-160H240v640h480v-440H560q-17 0-28.5-11.5T520-640ZM240-800v200-200 640-640Z" />
  </svg>
)

export const GridIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M200-520q-33 0-56.5-23.5T120-600v-160q0-33 23.5-56.5T200-840h160q33 0 56.5 23.5T440-760v160q0 33-23.5 56.5T360-520H200Zm0 400q-33 0-56.5-23.5T120-200v-160q0-33 23.5-56.5T200-440h160q33 0 56.5 23.5T440-360v160q0 33-23.5 56.5T360-120H200Zm400-400q-33 0-56.5-23.5T520-600v-160q0-33 23.5-56.5T600-840h160q33 0 56.5 23.5T840-760v160q0 33-23.5 56.5T760-520H600Zm0 400q-33 0-56.5-23.5T520-200v-160q0-33 23.5-56.5T600-440h160q33 0 56.5 23.5T840-360v160q0 33-23.5 56.5T760-120H600ZM200-600h160v-160H200v160Zm400 0h160v-160H600v160Zm0 400h160v-160H600v160Zm-400 0h160v-160H200v160Zm400-400Zm0 240Zm-240 0Zm0-240Z" />
  </svg>
)

export const UserIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-240v-32q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v32q0 33-23.5 56.5T720-160H240q-33 0-56.5-23.5T160-240Zm80 0h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" />
  </svg>
)

export const LightbulbIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM360-200q-17 0-28.5-11.5T320-240q0-17 11.5-28.5T360-280h240q17 0 28.5 11.5T640-240q0 17-11.5 28.5T600-200H360Zm-30-120q-69-41-109.5-110T180-580q0-125 87.5-212.5T480-880q125 0 212.5 87.5T780-580q0 81-40.5 150T630-320H330Zm24-80h252q45-32 69.5-79T700-580q0-92-64-156t-156-64q-92 0-156 64t-64 156q0 54 24.5 101t69.5 79Zm126 0Z" />
  </svg>
)

export const OrdersIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M160-240v-436L98-810q-7-15-1-30.5t21-22.5q15-7 30.5-1.5T171-844l77 166h464l77-166q7-15 22.5-21t30.5 2q15 7 21 22.5t-1 30.5l-62 134v436q0 33-23.5 56.5T720-160H240q-33 0-56.5-23.5T160-240Zm240-200h160q17 0 28.5-11.5T600-480q0-17-11.5-28.5T560-520H400q-17 0-28.5 11.5T360-480q0 17 11.5 28.5T400-440ZM240-240h480v-358H240v358Zm0 0v-358 358Z" />
  </svg>
)

export const PriceTagIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M446-80q-15 0-30-6t-27-18L103-390q-12-12-17.5-26.5T80-446q0-15 5.5-30t17.5-27l352-353q11-11 26-17.5t31-6.5h287q33 0 56.5 23.5T879-800v287q0 16-6 30.5T856-457L503-104q-12 12-27 18t-30 6Zm0-80 353-354v-286H513L160-446l286 286Zm253-480q25 0 42.5-17.5T759-700q0-25-17.5-42.5T699-760q-25 0-42.5 17.5T639-700q0 25 17.5 42.5T699-640ZM480-480Z" />
  </svg>
)

export const WalletIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V9C20 8.73478 19.8946 8.48043 19.7071 8.29289C19.5196 8.10536 19.2652 8 19 8H7C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6H19C19.7957 6 20.5587 6.31607 21.1213 6.87868C21.6839 7.44129 22 8.20435 22 9V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.5523 2 20 2.44772 20 3C20 3.55228 19.5523 4 19 4H5ZM16 14C16 13.4477 16.4477 13 17 13H17.01C17.5623 13 18.01 13.4477 18.01 14C18.01 14.5523 17.5623 15 17.01 15H17C16.4477 15 16 14.5523 16 14Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)

export const DashboardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M520-640v-160q0-17 11.5-28.5T560-840h240q17 0 28.5 11.5T840-800v160q0 17-11.5 28.5T800-600H560q-17 0-28.5-11.5T520-640ZM120-480v-320q0-17 11.5-28.5T160-840h240q17 0 28.5 11.5T440-800v320q0 17-11.5 28.5T400-440H160q-17 0-28.5-11.5T120-480Zm400 320v-320q0-17 11.5-28.5T560-520h240q17 0 28.5 11.5T840-480v320q0 17-11.5 28.5T800-120H560q-17 0-28.5-11.5T520-160Zm-400 0v-160q0-17 11.5-28.5T160-360h240q17 0 28.5 11.5T440-320v160q0 17-11.5 28.5T400-120H160q-17 0-28.5-11.5T120-160Zm80-360h160v-240H200v240Zm400 320h160v-240H600v240Zm0-480h160v-80H600v80ZM200-200h160v-80H200v80Zm160-320Zm240-160Zm0 240ZM360-280Z" />
  </svg>
)

export const TickIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="8"
    viewBox="0 0 11 8"
    width="11"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.86664 6.1L9.51664 0.45C9.64998 0.316667 9.80553 0.25 9.98331 0.25C10.1611 0.25 10.3166 0.316667 10.45 0.45C10.5833 0.583333 10.65 0.741667 10.65 0.925C10.65 1.10833 10.5833 1.26667 10.45 1.4L4.33331 7.53333C4.19998 7.66667 4.04442 7.73333 3.86664 7.73333C3.68886 7.73333 3.53331 7.66667 3.39998 7.53333L0.533309 4.66667C0.399975 4.53333 0.336086 4.375 0.341642 4.19167C0.347197 4.00833 0.416642 3.85 0.549975 3.71667C0.683309 3.58333 0.841642 3.51667 1.02498 3.51667C1.20831 3.51667 1.36664 3.58333 1.49998 3.71667L3.86664 6.1Z"
      fill="currentColor"
    />
  </svg>
)

export const XIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 17 16"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.49997 8.93337L5.2333 12.2C5.11108 12.3223 4.95553 12.3834 4.76664 12.3834C4.57775 12.3834 4.42219 12.3223 4.29997 12.2C4.17775 12.0778 4.11664 11.9223 4.11664 11.7334C4.11664 11.5445 4.17775 11.3889 4.29997 11.2667L7.56664 8.00003L4.29997 4.73337C4.17775 4.61114 4.11664 4.45559 4.11664 4.2667C4.11664 4.07781 4.17775 3.92225 4.29997 3.80003C4.42219 3.67781 4.57775 3.6167 4.76664 3.6167C4.95553 3.6167 5.11108 3.67781 5.2333 3.80003L8.49997 7.0667L11.7666 3.80003C11.8889 3.67781 12.0444 3.6167 12.2333 3.6167C12.4222 3.6167 12.5777 3.67781 12.7 3.80003C12.8222 3.92225 12.8833 4.07781 12.8833 4.2667C12.8833 4.45559 12.8222 4.61114 12.7 4.73337L9.4333 8.00003L12.7 11.2667C12.8222 11.3889 12.8833 11.5445 12.8833 11.7334C12.8833 11.9223 12.8222 12.0778 12.7 12.2C12.5777 12.3223 12.4222 12.3834 12.2333 12.3834C12.0444 12.3834 11.8889 12.3223 11.7666 12.2L8.49997 8.93337Z"
      fill="currentColor"
    />
  </svg>
)

export const EmptyContractIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="40"
    viewBox="0 0 41 40"
    width="41"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="fill-slate-a3"
      d="M0.5 20C0.5 8.95431 9.45431 0 20.5 0C31.5457 0 40.5 8.95431 40.5 20C40.5 31.0457 31.5457 40 20.5 40C9.45431 40 0.5 31.0457 0.5 20Z"
    />
    <path
      className="fill-slate-a12"
      d="M27.5 27.425L25.375 29.525L23.975 28.125L26.075 26L23.975 23.875L25.375 22.475L27.5 24.575L29.625 22.475L31.025 23.875L28.925 26L31.025 28.125L29.625 29.525L27.5 27.425ZM14.5 30C13.6667 30 12.9583 29.7083 12.375 29.125C11.7917 28.5417 11.5 27.8333 11.5 27V24H14.5V10H29.5V20.375C29.1833 20.2583 28.8583 20.1708 28.525 20.1125C28.1917 20.0542 27.85 20.025 27.5 20.025V12H16.5V24H21.85C21.7333 24.3167 21.6458 24.6417 21.5875 24.975C21.5292 25.3083 21.5 25.65 21.5 26H13.5V27C13.5 27.2833 13.5958 27.5208 13.7875 27.7125C13.9792 27.9042 14.2167 28 14.5 28H21.85C21.9833 28.3833 22.15 28.7417 22.35 29.075C22.55 29.4083 22.7833 29.7167 23.05 30H14.5ZM17.5 17V15H26.5V17H17.5ZM17.5 20V18H26.5V20H17.5Z"
    />
  </svg>
)

export const AttachFileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.5 15.75C18.5 17.4833 17.8917 18.9583 16.675 20.175C15.4583 21.3917 13.9833 22 12.25 22C10.5167 22 9.04167 21.3917 7.825 20.175C6.60833 18.9583 6 17.4833 6 15.75V6.5C6 5.25 6.4375 4.1875 7.3125 3.3125C8.1875 2.4375 9.25 2 10.5 2C11.75 2 12.8125 2.4375 13.6875 3.3125C14.5625 4.1875 15 5.25 15 6.5V15.25C15 16.0167 14.7333 16.6667 14.2 17.2C13.6667 17.7333 13.0167 18 12.25 18C11.4833 18 10.8333 17.7333 10.3 17.2C9.76667 16.6667 9.5 16.0167 9.5 15.25V7C9.5 6.71667 9.59583 6.47917 9.7875 6.2875C9.97917 6.09583 10.2167 6 10.5 6C10.7833 6 11.0208 6.09583 11.2125 6.2875C11.4042 6.47917 11.5 6.71667 11.5 7V15.25C11.5 15.4667 11.5708 15.6458 11.7125 15.7875C11.8542 15.9292 12.0333 16 12.25 16C12.4667 16 12.6458 15.9292 12.7875 15.7875C12.9292 15.6458 13 15.4667 13 15.25V6.5C12.9833 5.8 12.7375 5.20833 12.2625 4.725C11.7875 4.24167 11.2 4 10.5 4C9.8 4 9.20833 4.24167 8.725 4.725C8.24167 5.20833 8 5.8 8 6.5V15.75C7.98333 16.9333 8.39167 17.9375 9.225 18.7625C10.0583 19.5875 11.0667 20 12.25 20C13.4167 20 14.4083 19.5875 15.225 18.7625C16.0417 17.9375 16.4667 16.9333 16.5 15.75V7C16.5 6.71667 16.5958 6.47917 16.7875 6.2875C16.9792 6.09583 17.2167 6 17.5 6C17.7833 6 18.0208 6.09583 18.2125 6.2875C18.4042 6.47917 18.5 6.71667 18.5 7V15.75Z"
      fill="currentColor"
    />
  </svg>
)

export const TollIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 20C12.7667 20 10.875 19.225 9.325 17.675C7.775 16.125 7 14.2333 7 12C7 9.76667 7.775 7.875 9.325 6.325C10.875 4.775 12.7667 4 15 4C17.2333 4 19.125 4.775 20.675 6.325C22.225 7.875 23 9.76667 23 12C23 14.2333 22.225 16.125 20.675 17.675C19.125 19.225 17.2333 20 15 20ZM7 19.75C5.23333 19.2833 3.79167 18.3333 2.675 16.9C1.55833 15.4667 1 13.8333 1 12C1 10.1667 1.55833 8.53333 2.675 7.1C3.79167 5.66667 5.23333 4.71667 7 4.25V6.35C5.8 6.76667 4.83333 7.49167 4.1 8.525C3.36667 9.55833 3 10.7167 3 12C3 13.2833 3.36667 14.4417 4.1 15.475C4.83333 16.5083 5.8 17.2333 7 17.65V19.75ZM15 18C16.6667 18 18.0833 17.4167 19.25 16.25C20.4167 15.0833 21 13.6667 21 12C21 10.3333 20.4167 8.91667 19.25 7.75C18.0833 6.58333 16.6667 6 15 6C13.3333 6 11.9167 6.58333 10.75 7.75C9.58333 8.91667 9 10.3333 9 12C9 13.6667 9.58333 15.0833 10.75 16.25C11.9167 17.4167 13.3333 18 15 18Z"
      fill="currentColor"
    />
  </svg>
)

export const NotificationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 19V17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H20V19H4ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17Z"
      fill="currentColor"
    />
  </svg>
)

export const ScheduleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 11.6V8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8V11.975C11 12.1083 11.025 12.2375 11.075 12.3625C11.125 12.4875 11.2 12.6 11.3 12.7L14.6 16C14.7833 16.1833 15.0167 16.275 15.3 16.275C15.5833 16.275 15.8167 16.1833 16 16C16.1833 15.8167 16.275 15.5833 16.275 15.3C16.275 15.0167 16.1833 14.7833 16 14.6L13 11.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z"
      fill="currentColor"
    />
  </svg>
)

export const FileMagnifier = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 4V10.025V10V20V4ZM5.5 22C4.95 22 4.47917 21.8042 4.0875 21.4125C3.69583 21.0208 3.5 20.55 3.5 20V4C3.5 3.45 3.69583 2.97917 4.0875 2.5875C4.47917 2.19583 4.95 2 5.5 2H13.5L19.5 8V10.5C19.1833 10.3667 18.8583 10.2625 18.525 10.1875C18.1917 10.1125 17.85 10.0583 17.5 10.025V9H12.5V4H5.5V20H11.525C11.7917 20.4 12.0917 20.7708 12.425 21.1125C12.7583 21.4542 13.125 21.75 13.525 22H5.5ZM17 19C17.7 19 18.2917 18.7583 18.775 18.275C19.2583 17.7917 19.5 17.2 19.5 16.5C19.5 15.8 19.2583 15.2083 18.775 14.725C18.2917 14.2417 17.7 14 17 14C16.3 14 15.7083 14.2417 15.225 14.725C14.7417 15.2083 14.5 15.8 14.5 16.5C14.5 17.2 14.7417 17.7917 15.225 18.275C15.7083 18.7583 16.3 19 17 19ZM22.1 23L19.4 20.3C19.05 20.5333 18.6708 20.7083 18.2625 20.825C17.8542 20.9417 17.4333 21 17 21C15.75 21 14.6875 20.5625 13.8125 19.6875C12.9375 18.8125 12.5 17.75 12.5 16.5C12.5 15.25 12.9375 14.1875 13.8125 13.3125C14.6875 12.4375 15.75 12 17 12C18.25 12 19.3125 12.4375 20.1875 13.3125C21.0625 14.1875 21.5 15.25 21.5 16.5C21.5 16.9333 21.4417 17.3542 21.325 17.7625C21.2083 18.1708 21.0333 18.55 20.8 18.9L23.5 21.6L22.1 23Z"
      fill="currentColor"
    />
  </svg>
)

export const ConsumptionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 21.9502C9.44772 21.9502 9 21.5025 9 20.9502V19.4502C7.23333 18.8335 5.79167 17.7544 4.675 16.2127C3.55833 14.671 3 12.9169 3 10.9502C3 9.7002 3.2375 8.52936 3.7125 7.4377C4.1875 6.34603 4.82917 5.39603 5.6375 4.5877C6.44583 3.77936 7.39583 3.1377 8.4875 2.6627C9.57917 2.1877 10.7417 1.9502 11.975 1.9502C13.2083 1.9502 14.375 2.1877 15.475 2.6627C16.575 3.1377 17.5333 3.77936 18.35 4.5877C19.1667 5.39603 19.8125 6.34603 20.2875 7.4377C20.7625 8.52936 21 9.7002 21 10.9502C21 12.9169 20.4375 14.6627 19.3125 16.1877C18.1875 17.7127 16.75 18.7919 15 19.4252V20.9502C15 21.5025 14.5523 21.9502 14 21.9502C13.4477 21.9502 13 21.5025 13 20.9502V19.9002C12.8333 19.9335 12.6667 19.9502 12.5 19.9502H11.975C11.8083 19.9502 11.6458 19.946 11.4875 19.9377C11.3292 19.9294 11.1667 19.9169 11 19.9002V20.9502C11 21.5025 10.5523 21.9502 10 21.9502ZM12 18.0002C13.9333 18.0002 15.5833 17.3169 16.95 15.9502C18.3167 14.5835 19 12.9335 19 11.0002C19 9.06686 18.3167 7.41686 16.95 6.0502C15.5833 4.68353 13.9333 4.0002 12 4.0002C10.0667 4.0002 8.41667 4.68353 7.05 6.0502C5.68333 7.41686 5 9.06686 5 11.0002C5 12.9335 5.68333 14.5835 7.05 15.9502C8.41667 17.3169 10.0667 18.0002 12 18.0002ZM8 8.0002C8 8.55248 8.44772 9.0002 9 9.0002H15C15.5523 9.0002 16 8.55248 16 8.0002C16 7.44791 15.5523 7.0002 15 7.0002H9C8.44772 7.0002 8 7.44791 8 8.0002ZM10.5429 16.2931C10.9334 16.6836 11.5666 16.6836 11.9571 16.2931L13.5429 14.7073C13.9334 14.3168 13.9334 13.6836 13.5429 13.2931L13 12.7502L13.5429 12.2073C13.9334 11.8168 13.9334 11.1836 13.5429 10.7931L13.4571 10.7073C13.0666 10.3168 12.4334 10.3168 12.0429 10.7073L10.4571 12.2931C10.0666 12.6836 10.0666 13.3168 10.4571 13.7073L11 14.2502L10.4571 14.7931C10.0666 15.1836 10.0666 15.8168 10.4571 16.2073L10.5429 16.2931Z"
      fill="currentColor"
    />
  </svg>
)

export const AddIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12.5 4C13.0523 4 13.5 4.44772 13.5 5V11H19.5C20.0523 11 20.5 11.4477 20.5 12C20.5 12.5523 20.0523 13 19.5 13H13.5V19C13.5 19.5523 13.0523 20 12.5 20C11.9477 20 11.5 19.5523 11.5 19V13H5.5C4.94772 13 4.5 12.5523 4.5 12C4.5 11.4477 4.94772 11 5.5 11H11.5V5C11.5 4.44772 11.9477 4 12.5 4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)

export const FeedOutIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 5.825L6.4 10.4L5 9L12 2L19 9L17.6 10.425L13 5.825V13H11V5.825ZM11 18V15H13V18H11ZM11 22V20H13V22H11Z"
      fill="currentColor"
    />
  </svg>
)

export const FeedInIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22L5 15L6.4 13.575L11 18.175V11H13V18.175L17.6 13.6L19 15L12 22ZM11 9V6H13V9H11ZM11 4V2H13V4H11Z"
      fill="currentColor"
    />
  </svg>
)

export const EmptyReadingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    className="size-12"
    fill="none"
    height="40"
    role="presentation"
    viewBox="0 0 41 40"
    width="41"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="fill-slate-a3"
      d="M0.5 20C0.5 8.95431 9.45431 0 20.5 0V0C31.5457 0 40.5 8.95431 40.5 20V20C40.5 31.0457 31.5457 40 20.5 40V40C9.45431 40 0.5 31.0457 0.5 20V20Z"
    />
    <path
      d="M13.5 12V18.025V18V28V12ZM13.5 30C12.95 30 12.4792 29.8042 12.0875 29.4125C11.6958 29.0208 11.5 28.55 11.5 28V12C11.5 11.45 11.6958 10.9792 12.0875 10.5875C12.4792 10.1958 12.95 10 13.5 10H21.5L27.5 16V18.5C27.1833 18.3667 26.8583 18.2625 26.525 18.1875C26.1917 18.1125 25.85 18.0583 25.5 18.025V17H20.5V12H13.5V28H19.525C19.7917 28.4 20.0917 28.7708 20.425 29.1125C20.7583 29.4542 21.125 29.75 21.525 30H13.5ZM25 27C25.7 27 26.2917 26.7583 26.775 26.275C27.2583 25.7917 27.5 25.2 27.5 24.5C27.5 23.8 27.2583 23.2083 26.775 22.725C26.2917 22.2417 25.7 22 25 22C24.3 22 23.7083 22.2417 23.225 22.725C22.7417 23.2083 22.5 23.8 22.5 24.5C22.5 25.2 22.7417 25.7917 23.225 26.275C23.7083 26.7583 24.3 27 25 27ZM30.1 31L27.4 28.3C27.05 28.5333 26.6708 28.7083 26.2625 28.825C25.8542 28.9417 25.4333 29 25 29C23.75 29 22.6875 28.5625 21.8125 27.6875C20.9375 26.8125 20.5 25.75 20.5 24.5C20.5 23.25 20.9375 22.1875 21.8125 21.3125C22.6875 20.4375 23.75 20 25 20C26.25 20 27.3125 20.4375 28.1875 21.3125C29.0625 22.1875 29.5 23.25 29.5 24.5C29.5 24.9333 29.4417 25.3542 29.325 25.7625C29.2083 26.1708 29.0333 26.55 28.8 26.9L31.5 29.6L30.1 31Z"
      fill="currentColor"
      transform="scale(0.8) translate(5, 5)"
    />
  </svg>
)

export const SelectArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9752 14.475L8.3502 10.85C8.3002 10.8 8.2627 10.7458 8.2377 10.6875C8.2127 10.6292 8.2002 10.5667 8.2002 10.5C8.2002 10.3667 8.24603 10.25 8.3377 10.15C8.42936 10.05 8.5502 10 8.7002 10H16.3002C16.4502 10 16.571 10.05 16.6627 10.15C16.7544 10.25 16.8002 10.3667 16.8002 10.5C16.8002 10.5333 16.7502 10.65 16.6502 10.85L13.0252 14.475C12.9419 14.5583 12.8585 14.6167 12.7752 14.65C12.6919 14.6833 12.6002 14.7 12.5002 14.7C12.4002 14.7 12.3085 14.6833 12.2252 14.65C12.1419 14.6167 12.0585 14.5583 11.9752 14.475Z"
      fill="currentColor"
    />
  </svg>
)

export const ArrowRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.6 11.9998L8.69999 8.0998C8.51665 7.91647 8.42499 7.68314 8.42499 7.3998C8.42499 7.11647 8.51665 6.88314 8.69999 6.6998C8.88332 6.51647 9.11665 6.4248 9.39999 6.4248C9.68332 6.4248 9.91665 6.51647 10.1 6.6998L14.7 11.2998C14.8 11.3998 14.8708 11.5081 14.9125 11.6248C14.9542 11.7415 14.975 11.8665 14.975 11.9998C14.975 12.1331 14.9542 12.2581 14.9125 12.3748C14.8708 12.4915 14.8 12.5998 14.7 12.6998L10.1 17.2998C9.91665 17.4831 9.68332 17.5748 9.39999 17.5748C9.11665 17.5748 8.88332 17.4831 8.69999 17.2998C8.51665 17.1165 8.42499 16.8831 8.42499 16.5998C8.42499 16.3165 8.51665 16.0831 8.69999 15.8998L12.6 11.9998Z"
      fill="currentColor"
    />
  </svg>
)

export const ErrorTriangleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.5 21L12.5 2L23.5 21H1.5ZM4.95 19H20.05L12.5 6L4.95 19ZM12.5 18C12.7833 18 13.0208 17.9042 13.2125 17.7125C13.4042 17.5208 13.5 17.2833 13.5 17C13.5 16.7167 13.4042 16.4792 13.2125 16.2875C13.0208 16.0958 12.7833 16 12.5 16C12.2167 16 11.9792 16.0958 11.7875 16.2875C11.5958 16.4792 11.5 16.7167 11.5 17C11.5 17.2833 11.5958 17.5208 11.7875 17.7125C11.9792 17.9042 12.2167 18 12.5 18ZM11.5 15H13.5V10H11.5V15Z"
      fill="currentColor"
    />
  </svg>
)

export const CameraIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5 17.5C13.75 17.5 14.8125 17.0625 15.6875 16.1875C16.5625 15.3125 17 14.25 17 13C17 11.75 16.5625 10.6875 15.6875 9.8125C14.8125 8.9375 13.75 8.5 12.5 8.5C11.25 8.5 10.1875 8.9375 9.3125 9.8125C8.4375 10.6875 8 11.75 8 13C8 14.25 8.4375 15.3125 9.3125 16.1875C10.1875 17.0625 11.25 17.5 12.5 17.5ZM12.5 15.5C11.8 15.5 11.2083 15.2583 10.725 14.775C10.2417 14.2917 10 13.7 10 13C10 12.3 10.2417 11.7083 10.725 11.225C11.2083 10.7417 11.8 10.5 12.5 10.5C13.2 10.5 13.7917 10.7417 14.275 11.225C14.7583 11.7083 15 12.3 15 13C15 13.7 14.7583 14.2917 14.275 14.775C13.7917 15.2583 13.2 15.5 12.5 15.5ZM4.5 21C3.95 21 3.47917 20.8042 3.0875 20.4125C2.69583 20.0208 2.5 19.55 2.5 19V7C2.5 6.45 2.69583 5.97917 3.0875 5.5875C3.47917 5.19583 3.95 5 4.5 5H7.65L9.5 3H15.5L17.35 5H20.5C21.05 5 21.5208 5.19583 21.9125 5.5875C22.3042 5.97917 22.5 6.45 22.5 7V19C22.5 19.55 22.3042 20.0208 21.9125 20.4125C21.5208 20.8042 21.05 21 20.5 21H4.5ZM4.5 19H20.5V7H16.45L14.625 5H10.375L8.55 7H4.5V19Z"
      fill="currentColor"
    />
  </svg>
)

export const RefreshIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="21"
    viewBox="0 0 19 21"
    width="19"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 21C8.25 21 7.07917 20.7625 5.9875 20.2875C4.89583 19.8125 3.94583 19.1708 3.1375 18.3625C2.32917 17.5542 1.6875 16.6042 1.2125 15.5125C0.7375 14.4208 0.5 13.25 0.5 12H2.5C2.5 13.95 3.17917 15.6042 4.5375 16.9625C5.89583 18.3208 7.55 19 9.5 19C11.45 19 13.1042 18.3208 14.4625 16.9625C15.8208 15.6042 16.5 13.95 16.5 12C16.5 10.05 15.8208 8.39583 14.4625 7.0375C13.1042 5.67917 11.45 5 9.5 5H9.35L10.9 6.55L9.5 8L5.5 4L9.5 0L10.9 1.45L9.35 3H9.5C10.75 3 11.9208 3.2375 13.0125 3.7125C14.1042 4.1875 15.0542 4.82917 15.8625 5.6375C16.6708 6.44583 17.3125 7.39583 17.7875 8.4875C18.2625 9.57917 18.5 10.75 18.5 12C18.5 13.25 18.2625 14.4208 17.7875 15.5125C17.3125 16.6042 16.6708 17.5542 15.8625 18.3625C15.0542 19.1708 14.1042 19.8125 13.0125 20.2875C11.9208 20.7625 10.75 21 9.5 21Z"
      fill="currentColor"
    />
  </svg>
)

export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)

export const BlockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.9 20 13.7667 19.8542 14.6 19.5625C15.4333 19.2708 16.2 18.85 16.9 18.3L5.7 7.1C5.15 7.8 4.72917 8.56667 4.4375 9.4C4.14583 10.2333 4 11.1 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM18.3 16.9C18.85 16.2 19.2708 15.4333 19.5625 14.6C19.8542 13.7667 20 12.9 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C11.1 4 10.2333 4.14583 9.4 4.4375C8.56667 4.72917 7.8 5.15 7.1 5.7L18.3 16.9Z"
      fill="currentColor"
    />
  </svg>
)

export const OfflineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M769-89 390-467q-44 11-82 32t-70 50l-68-68q32-29 67.5-52t76.5-39L205-653q-38 20-72 44.5T68-555L0-623q30-29 64-54t71-46l-45-45 51-51 679 679-51 51Zm-289-55q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm242-242q-26-23-55.5-41T604-457L486-575q88 1 166 33t138 88l-68 68Zm170-169q-81-77-186.5-121T480-720q-32 0-63.5 3.5T355-706l-79-79q48-15 99-23t105-8q140 0 263 51.5T960-623l-68 68Z" />
  </svg>
)

export const SparklesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7.39597 0.869791C7.56984 0.737897 7.78209 0.666504 8.00033 0.666504C8.21857 0.666504 8.43081 0.737897 8.60469 0.869791C8.77856 1.00168 8.90451 1.18684 8.96333 1.397L8.9669 1.4103L10.0209 5.50014C10.0506 5.61549 10.1107 5.72077 10.195 5.80501C10.2792 5.88921 10.3844 5.94932 10.4997 5.9791C10.4996 5.97908 10.4998 5.97911 10.4997 5.9791L14.5897 7.0331L14.6006 7.036C14.8116 7.0942 14.9977 7.22002 15.1303 7.39416C15.2629 7.56829 15.3347 7.78113 15.3347 8C15.3347 8.21888 15.2629 8.43171 15.1303 8.60585C14.9977 8.77998 14.8116 8.9058 14.6006 8.964L14.5897 8.96691L10.4999 10.0209C10.3845 10.0506 10.2792 10.1108 10.195 10.195C10.1107 10.2792 10.0506 10.3845 10.0209 10.4999L8.96621 14.5898L8.96266 14.603C8.90385 14.8132 8.77789 14.9983 8.60402 15.1302C8.43015 15.2621 8.2179 15.3335 7.99966 15.3335C7.78142 15.3335 7.56917 15.2621 7.3953 15.1302C7.22143 14.9983 7.09548 14.8132 7.03666 14.603L7.03309 14.5897L5.97913 10.4999C5.97912 10.4998 5.97915 10.4999 5.97913 10.4999C5.94936 10.3846 5.8892 10.2792 5.805 10.195C5.72076 10.1108 5.61549 10.0506 5.50013 10.0209L1.4102 8.96622L1.39463 8.962C1.18529 8.90259 1.00105 8.77651 0.869854 8.60289C0.73866 8.42928 0.667679 8.21761 0.667679 8C0.667679 7.7824 0.73866 7.57073 0.869854 7.39711C1.00105 7.2235 1.18529 7.09742 1.39463 7.038L1.4101 7.03381L5.5001 5.97848C5.61542 5.94875 5.72079 5.88864 5.80502 5.80446C5.88922 5.72033 5.94935 5.61519 5.97918 5.49996C5.97916 5.50003 5.97919 5.4999 5.97918 5.49996L7.03378 1.41021L7.03733 1.397C7.09614 1.18684 7.2221 1.00169 7.39597 0.869791ZM8.00023 3.00213L8.72975 5.83304C8.81903 6.17911 8.99946 6.4951 9.25218 6.74782C9.5049 7.00054 9.82073 7.18092 10.1668 7.2702L12.9988 8L10.167 8.72976C9.82089 8.81904 9.5049 8.99947 9.25218 9.25219C8.99946 9.50491 8.81908 9.82073 8.7298 10.1668L7.99976 12.9979L7.27024 10.167C7.18096 9.8209 7.00053 9.50491 6.74781 9.25219C6.49509 8.99947 6.17927 8.81908 5.83319 8.7298L3.00262 7.9999L5.8331 7.26956C5.83306 7.26957 5.83314 7.26955 5.8331 7.26956C6.179 7.18035 6.49482 7.0001 6.7475 6.7476C7.00021 6.49506 7.18067 6.17945 7.2701 5.83356L8.00023 3.00213ZM13.3333 1.33334C13.7015 1.33334 14 1.63181 14 2V2.66667H14.6667C15.0349 2.66667 15.3333 2.96515 15.3333 3.33334C15.3333 3.70153 15.0349 4 14.6667 4H14V4.66667C14 5.03486 13.7015 5.33334 13.3333 5.33334C12.9651 5.33334 12.6667 5.03486 12.6667 4.66667V4H12C11.6318 4 11.3333 3.70153 11.3333 3.33334C11.3333 2.96515 11.6318 2.66667 12 2.66667H12.6667V2C12.6667 1.63181 12.9651 1.33334 13.3333 1.33334ZM2.66666 10.6667C3.03485 10.6667 3.33333 10.9651 3.33333 11.3333C3.70152 11.3333 4 11.6318 4 12C4 12.3682 3.70152 12.6667 3.33333 12.6667C3.33333 13.0349 3.03485 13.3333 2.66666 13.3333C2.29847 13.3333 2 13.0349 2 12.6667C1.63181 12.6667 1.33333 12.3682 1.33333 12C1.33333 11.6318 1.63181 11.3333 2 11.3333C2 10.9651 2.29847 10.6667 2.66666 10.6667Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)

export const MicrosoftLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4.5 4H12.119V11.619H4.5V4Z" fill="#F35325" />
    <path d="M12.881 4H20.5V11.619H12.881V4Z" fill="#81BC06" />
    <path d="M4.5 12.381H12.119V20H4.5V12.381Z" fill="#05A6F0" />
    <path d="M12.881 12.381H20.5V20H12.881V12.381Z" fill="#FFBA08" />
  </svg>
)

export const GoogleLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.102 12.2398C22.102 11.5644 22.0367 10.8673 21.9277 10.2137H12.4944V14.0698H17.8973C17.6795 15.3116 16.9605 16.4009 15.893 17.0981L19.1173 19.6035C21.0127 17.8388 22.102 15.2681 22.102 12.2398Z"
      fill="#4280EF"
    />
    <path
      d="M12.4944 22C15.1959 22 17.4616 21.1067 19.1174 19.5817L15.893 17.0981C14.9998 17.7081 13.8451 18.0567 12.4944 18.0567C9.88006 18.0567 7.67967 16.292 6.87359 13.9391L3.5621 16.4881C5.26142 19.8649 8.70362 22 12.4944 22Z"
      fill="#34A353"
    />
    <path
      d="M6.87355 13.9174C6.45962 12.6756 6.45962 11.3248 6.87355 10.083L3.56207 7.51227C2.14598 10.3445 2.14598 13.6777 3.56207 16.4881L6.87355 13.9174Z"
      fill="#F6B704"
    />
    <path
      d="M12.4944 5.96543C13.9105 5.94365 15.3048 6.4883 16.3287 7.46867L19.1827 4.59291C17.3745 2.89359 14.978 1.97858 12.4944 2.00036C8.70362 2.00036 5.26142 4.1354 3.5621 7.51224L6.87359 10.083C7.67967 7.70832 9.88006 5.96543 12.4944 5.96543Z"
      fill="#E54335"
    />
  </svg>
)

export const FacebookLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 25 24"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.5 12C22.5 6.4772 18.0228 2 12.5 2C6.9772 2 2.5 6.4772 2.5 12C2.5 16.6896 5.7288 20.6248 10.0844 21.7056V15.056H8.0224V12H10.0844V10.6832C10.0844 7.2796 11.6248 5.702 14.9664 5.702C15.6 5.702 16.6932 5.8264 17.1404 5.9504V8.7204C16.9044 8.6956 16.4944 8.6832 15.9852 8.6832C14.3456 8.6832 13.712 9.3044 13.712 10.9192V12H16.9784L16.4172 15.056H13.712V21.9268C18.6636 21.3288 22.5004 17.1128 22.5004 12H22.5Z"
      fill="#0866FF"
    />
    <path
      d="M16.4168 15.056L16.978 12H13.7116V10.9192C13.7116 9.3044 14.3452 8.6832 15.9848 8.6832C16.494 8.6832 16.904 8.6956 17.14 8.7204V5.9504C16.6928 5.826 15.5996 5.702 14.966 5.702C11.6244 5.702 10.084 7.2796 10.084 10.6832V12H8.022V15.056H10.084V21.7056C10.8576 21.8976 11.6668 22 12.4996 22C12.9096 22 13.314 21.9748 13.7112 21.9268V15.056H16.4164H16.4168Z"
      fill="white"
    />
  </svg>
)

export const AppleLogo = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="48"
    viewBox="0 0 48 48"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={cn('old-design-override', className)}
  >
    <path
      className="fill-[#2C333B] dark:fill-[#fff]"
      d="M39.7676 17.3608C39.5279 17.5487 35.2963 19.9572 35.2963 25.3128C35.2963 31.5075 40.6809 33.699 40.842 33.7532C40.8172 33.8868 39.9866 36.7545 38.0031 39.6765C36.2343 42.2479 34.3872 44.8151 31.5771 44.8151C28.7671 44.8151 28.0439 43.1663 24.8 43.1663C21.6387 43.1663 20.5147 44.8693 17.9443 44.8693C15.3739 44.8693 13.5805 42.49 11.5184 39.568C9.12985 36.1368 7.2 30.8062 7.2 25.747C7.2 17.6322 12.4233 13.3284 17.5641 13.3284C20.2956 13.3284 22.5726 15.1401 24.2876 15.1401C25.9198 15.1401 28.4654 13.2199 31.573 13.2199C32.7507 13.2199 36.9823 13.3284 39.7676 17.3608ZM30.0977 9.78449C31.3829 8.24418 32.292 6.10694 32.292 3.96971C32.292 3.67333 32.2672 3.37278 32.2135 3.13068C30.1225 3.20999 27.6348 4.53741 26.1347 6.29478C24.957 7.64725 23.8578 9.78449 23.8578 11.9509C23.8578 12.2766 23.9115 12.6021 23.9363 12.7065C24.0685 12.7315 24.2834 12.7608 24.4983 12.7608C26.3744 12.7608 28.734 11.4918 30.0977 9.78449Z"
    />
  </svg>
)

export const DefaultSSOLogo = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="48"
    viewBox="0 0 48 48"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={cn('old-design-override', className)}
  >
    <path
      className="fill-[#00080C] dark:fill-[#fff]"
      clipRule="evenodd"
      d="M5.075 36.9202C7.125 38.9734 9.61667 40 12.55 40H37.55C39.85 40 41.8333 39.1654 43.5 37.4961C45.1667 35.8268 46 33.8404 46 31.5368C46 29.0662 45.1667 27.0214 43.5 25.4022C41.8333 23.783 39.8 23.0068 37.4 23.0736V21.8717C37.4 18.0657 36.1167 14.8023 33.55 12.0814C30.9833 9.36046 27.8333 8 24.1 8C20.8667 8 18.0167 9.0266 15.55 11.0798C13.0833 13.133 11.5167 15.7788 10.85 19.0172C8.28333 19.4178 6.16667 20.603 4.5 22.5728C2.83333 24.5425 2 26.8294 2 29.4335C2 32.3714 3.025 34.867 5.075 36.9202ZM31.6465 26C32.3025 26 32.8585 26.072 33.3145 26.216C33.7705 26.352 34.1345 26.584 34.4065 26.912C34.6865 27.232 34.8905 27.672 35.0185 28.232C35.1465 28.784 35.2105 29.476 35.2105 30.308C35.2105 31.14 35.1465 31.836 35.0185 32.396C34.8905 32.948 34.6865 33.388 34.4065 33.716C34.1345 34.036 33.7705 34.268 33.3145 34.412C32.8585 34.548 32.3025 34.616 31.6465 34.616C30.9905 34.616 30.4345 34.548 29.9785 34.412C29.5225 34.268 29.1545 34.036 28.8745 33.716C28.5945 33.388 28.3905 32.948 28.2625 32.396C28.1345 31.836 28.0705 31.14 28.0705 30.308C28.0705 29.476 28.1345 28.784 28.2625 28.232C28.3905 27.672 28.5945 27.232 28.8745 26.912C29.1545 26.584 29.5225 26.352 29.9785 26.216C30.4345 26.072 30.9905 26 31.6465 26ZM31.6465 27.452C31.2225 27.452 30.8905 27.536 30.6505 27.704C30.4185 27.872 30.2505 28.164 30.1465 28.58C30.0505 28.988 30.0025 29.564 30.0025 30.308C30.0025 31.044 30.0505 31.62 30.1465 32.036C30.2505 32.452 30.4185 32.744 30.6505 32.912C30.8905 33.08 31.2225 33.164 31.6465 33.164C32.0625 33.164 32.3865 33.08 32.6185 32.912C32.8585 32.744 33.0265 32.452 33.1225 32.036C33.2265 31.62 33.2785 31.044 33.2785 30.308C33.2785 29.564 33.2265 28.988 33.1225 28.58C33.0265 28.164 32.8585 27.872 32.6185 27.704C32.3865 27.536 32.0625 27.452 31.6465 27.452ZM23.5713 26.012C23.9793 26.012 24.4233 26.036 24.9033 26.084C25.3833 26.124 25.8513 26.212 26.3073 26.348L26.1873 27.56C25.8353 27.552 25.4233 27.544 24.9513 27.536C24.4793 27.528 24.0153 27.524 23.5593 27.524C23.3353 27.524 23.1433 27.532 22.9833 27.548C22.8313 27.556 22.7073 27.588 22.6113 27.644C22.5153 27.692 22.4473 27.768 22.4073 27.872C22.3673 27.976 22.3473 28.12 22.3473 28.304C22.3473 28.584 22.4113 28.788 22.5393 28.916C22.6753 29.044 22.9033 29.16 23.2233 29.264L24.8193 29.78C25.4833 30.004 25.9433 30.308 26.1993 30.692C26.4553 31.076 26.5833 31.58 26.5833 32.204C26.5833 32.676 26.5273 33.068 26.4153 33.38C26.3033 33.692 26.1273 33.936 25.8873 34.112C25.6473 34.288 25.3313 34.412 24.9393 34.484C24.5473 34.564 24.0673 34.604 23.4993 34.604C23.2273 34.604 22.8393 34.584 22.3353 34.544C21.8313 34.512 21.2553 34.424 20.6073 34.28L20.7273 32.984C21.1993 32.992 21.6073 33.004 21.9513 33.02C22.3033 33.028 22.6033 33.036 22.8513 33.044H23.4993C23.8193 33.044 24.0673 33.024 24.2433 32.984C24.4273 32.944 24.5553 32.864 24.6273 32.744C24.6993 32.624 24.7353 32.452 24.7353 32.228C24.7353 32.036 24.7073 31.884 24.6513 31.772C24.6033 31.652 24.5193 31.56 24.3993 31.496C24.2873 31.424 24.1313 31.36 23.9313 31.304L22.2513 30.728C21.6193 30.496 21.1713 30.192 20.9073 29.816C20.6433 29.44 20.5113 28.944 20.5113 28.328C20.5113 27.848 20.5673 27.46 20.6793 27.164C20.7993 26.86 20.9793 26.624 21.2193 26.456C21.4673 26.288 21.7833 26.172 22.1673 26.108C22.5593 26.044 23.0273 26.012 23.5713 26.012ZM17.392 26.084C16.912 26.036 16.468 26.012 16.06 26.012C15.516 26.012 15.048 26.044 14.656 26.108C14.272 26.172 13.956 26.288 13.708 26.456C13.468 26.624 13.288 26.86 13.168 27.164C13.056 27.46 13 27.848 13 28.328C13 28.944 13.132 29.44 13.396 29.816C13.66 30.192 14.108 30.496 14.74 30.728L16.42 31.304C16.62 31.36 16.776 31.424 16.888 31.496C17.008 31.56 17.092 31.652 17.14 31.772C17.196 31.884 17.224 32.036 17.224 32.228C17.224 32.452 17.188 32.624 17.116 32.744C17.044 32.864 16.916 32.944 16.732 32.984C16.556 33.024 16.308 33.044 15.988 33.044H15.34C15.092 33.036 14.792 33.028 14.44 33.02C14.096 33.004 13.688 32.992 13.216 32.984L13.096 34.28C13.744 34.424 14.32 34.512 14.824 34.544C15.328 34.584 15.716 34.604 15.988 34.604C16.556 34.604 17.036 34.564 17.428 34.484C17.82 34.412 18.136 34.288 18.376 34.112C18.616 33.936 18.792 33.692 18.904 33.38C19.016 33.068 19.072 32.676 19.072 32.204C19.072 31.58 18.944 31.076 18.688 30.692C18.432 30.308 17.972 30.004 17.308 29.78L15.712 29.264C15.392 29.16 15.164 29.044 15.028 28.916C14.9 28.788 14.836 28.584 14.836 28.304C14.836 28.12 14.856 27.976 14.896 27.872C14.936 27.768 15.004 27.692 15.1 27.644C15.196 27.588 15.32 27.556 15.472 27.548C15.632 27.532 15.824 27.524 16.048 27.524C16.504 27.524 16.968 27.528 17.44 27.536C17.912 27.544 18.324 27.552 18.676 27.56L18.796 26.348C18.34 26.212 17.872 26.124 17.392 26.084Z"
      fillRule="evenodd"
    />
  </svg>
)

export const MissingDocumentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 4V10.025V10V20V4ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V4C3 3.45 3.19583 2.97917 3.5875 2.5875C3.97917 2.19583 4.45 2 5 2H13L19 8V10.5C18.6833 10.3667 18.3583 10.2625 18.025 10.1875C17.6917 10.1125 17.35 10.0583 17 10.025V9H12V4H5V20H11.025C11.2917 20.4 11.5917 20.7708 11.925 21.1125C12.2583 21.4542 12.625 21.75 13.025 22H5ZM16.5 19C17.2 19 17.7917 18.7583 18.275 18.275C18.7583 17.7917 19 17.2 19 16.5C19 15.8 18.7583 15.2083 18.275 14.725C17.7917 14.2417 17.2 14 16.5 14C15.8 14 15.2083 14.2417 14.725 14.725C14.2417 15.2083 14 15.8 14 16.5C14 17.2 14.2417 17.7917 14.725 18.275C15.2083 18.7583 15.8 19 16.5 19ZM21.6 23L18.9 20.3C18.55 20.5333 18.1708 20.7083 17.7625 20.825C17.3542 20.9417 16.9333 21 16.5 21C15.25 21 14.1875 20.5625 13.3125 19.6875C12.4375 18.8125 12 17.75 12 16.5C12 15.25 12.4375 14.1875 13.3125 13.3125C14.1875 12.4375 15.25 12 16.5 12C17.75 12 18.8125 12.4375 19.6875 13.3125C20.5625 14.1875 21 15.25 21 16.5C21 16.9333 20.9417 17.3542 20.825 17.7625C20.7083 18.1708 20.5333 18.55 20.3 18.9L23 21.6L21.6 23Z"
      fill="currentColor"
    />
  </svg>
)

export const MissingMeterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 21.95C9.44772 21.95 9 21.5023 9 20.95V19.45C7.23333 18.8333 5.79167 17.7542 4.675 16.2125C3.55833 14.6708 3 12.9167 3 10.95C3 9.7 3.2375 8.52916 3.7125 7.4375C4.1875 6.34583 4.82917 5.39583 5.6375 4.5875C6.44583 3.77916 7.39583 3.1375 8.4875 2.6625C9.57917 2.1875 10.7417 1.95 11.975 1.95C13.2083 1.95 14.375 2.1875 15.475 2.6625C16.575 3.1375 17.5333 3.77916 18.35 4.5875C19.1667 5.39583 19.8125 6.34583 20.2875 7.4375C20.7625 8.52916 21 9.7 21 10.95C21 12.9167 20.4375 14.6625 19.3125 16.1875C18.1875 17.7125 16.75 18.7917 15 19.425V20.95C15 21.5023 14.5523 21.95 14 21.95C13.4477 21.95 13 21.5023 13 20.95V19.9C12.8333 19.9333 12.6667 19.95 12.5 19.95H11.975C11.8083 19.95 11.6458 19.9458 11.4875 19.9375C11.3292 19.9292 11.1667 19.9167 11 19.9V20.95C11 21.5023 10.5523 21.95 10 21.95ZM12 18C13.9333 18 15.5833 17.3167 16.95 15.95C18.3167 14.5833 19 12.9333 19 11C19 9.06666 18.3167 7.41666 16.95 6.05C15.5833 4.68333 13.9333 4 12 4C10.0667 4 8.41667 4.68333 7.05 6.05C5.68333 7.41666 5 9.06666 5 11C5 12.9333 5.68333 14.5833 7.05 15.95C8.41667 17.3167 10.0667 18 12 18ZM8 8C8 8.55228 8.44772 9 9 9H15C15.5523 9 16 8.55228 16 8C16 7.44771 15.5523 7 15 7H9C8.44772 7 8 7.44771 8 8ZM10.5429 16.2929C10.9334 16.6834 11.5666 16.6834 11.9571 16.2929L13.5429 14.7071C13.9334 14.3166 13.9334 13.6834 13.5429 13.2929L13 12.75L13.5429 12.2071C13.9334 11.8166 13.9334 11.1834 13.5429 10.7929L13.4571 10.7071C13.0666 10.3166 12.4334 10.3166 12.0429 10.7071L10.4571 12.2929C10.0666 12.6834 10.0666 13.3166 10.4571 13.7071L11 14.25L10.4571 14.7929C10.0666 15.1834 10.0666 15.8166 10.4571 16.2071L10.5429 16.2929Z"
      fill="currentColor"
    />
  </svg>
)

export const EmptyGeneralIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 21 20"
    width="21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5 17.425L14.375 19.525L12.975 18.125L15.075 16L12.975 13.875L14.375 12.475L16.5 14.575L18.625 12.475L20.025 13.875L17.925 16L20.025 18.125L18.625 19.525L16.5 17.425ZM3.5 20C2.66667 20 1.95833 19.7083 1.375 19.125C0.791667 18.5417 0.5 17.8333 0.5 17V14H3.5V0H18.5V10.375C18.1833 10.2583 17.8583 10.1708 17.525 10.1125C17.1917 10.0542 16.85 10.025 16.5 10.025V2H5.5V14H10.85C10.7333 14.3167 10.6458 14.6417 10.5875 14.975C10.5292 15.3083 10.5 15.65 10.5 16H2.5V17C2.5 17.2833 2.59583 17.5208 2.7875 17.7125C2.97917 17.9042 3.21667 18 3.5 18H10.85C10.9833 18.3833 11.15 18.7417 11.35 19.075C11.55 19.4083 11.7833 19.7167 12.05 20H3.5ZM6.5 7V5H15.5V7H6.5ZM6.5 10V8H15.5V10H6.5Z"
      fill="currentColor"
      fillOpacity="0.934"
    />
  </svg>
)

export const CancelledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="10"
    viewBox="0 0 10 10"
    width="10"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.07959 1L8.99999 9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <path
      d="M8.92041 1L1.00001 9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </svg>
)

export const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.3335 11.3333H8.66683V7.33334H7.3335V11.3333ZM8.00016 6.00001C8.18905 6.00001 8.34739 5.93612 8.47516 5.80834C8.60294 5.68057 8.66683 5.52223 8.66683 5.33334C8.66683 5.14445 8.60294 4.98612 8.47516 4.85834C8.34739 4.73057 8.18905 4.66668 8.00016 4.66668C7.81127 4.66668 7.65294 4.73057 7.52516 4.85834C7.39739 4.98612 7.3335 5.14445 7.3335 5.33334C7.3335 5.52223 7.39739 5.68057 7.52516 5.80834C7.65294 5.93612 7.81127 6.00001 8.00016 6.00001ZM8.00016 14.6667C7.07794 14.6667 6.21127 14.4917 5.40016 14.1417C4.58905 13.7917 3.8835 13.3167 3.2835 12.7167C2.6835 12.1167 2.2085 11.4111 1.8585 10.6C1.5085 9.7889 1.3335 8.92223 1.3335 8.00001C1.3335 7.07779 1.5085 6.21112 1.8585 5.40001C2.2085 4.5889 2.6835 3.88334 3.2835 3.28334C3.8835 2.68334 4.58905 2.20834 5.40016 1.85834C6.21127 1.50834 7.07794 1.33334 8.00016 1.33334C8.92239 1.33334 9.78905 1.50834 10.6002 1.85834C11.4113 2.20834 12.1168 2.68334 12.7168 3.28334C13.3168 3.88334 13.7918 4.5889 14.1418 5.40001C14.4918 6.21112 14.6668 7.07779 14.6668 8.00001C14.6668 8.92223 14.4918 9.7889 14.1418 10.6C13.7918 11.4111 13.3168 12.1167 12.7168 12.7167C12.1168 13.3167 11.4113 13.7917 10.6002 14.1417C9.78905 14.4917 8.92239 14.6667 8.00016 14.6667ZM8.00016 13.3333C9.48905 13.3333 10.7502 12.8167 11.7835 11.7833C12.8168 10.75 13.3335 9.4889 13.3335 8.00001C13.3335 6.51112 12.8168 5.25001 11.7835 4.21668C10.7502 3.18334 9.48905 2.66668 8.00016 2.66668C6.51127 2.66668 5.25016 3.18334 4.21683 4.21668C3.1835 5.25001 2.66683 6.51112 2.66683 8.00001C2.66683 9.4889 3.1835 10.75 4.21683 11.7833C5.25016 12.8167 6.51127 13.3333 8.00016 13.3333Z"
      fill="currentColor"
    />
  </svg>
)

export const ProgressIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="44"
    viewBox="0 0 40 40"
    width="44"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="4" />
    <path
      clipRule="evenodd"
      d="M20 9C21.1046 9 22 9.89543 22 11V20.1716L26.4142 24.5858C27.1953 25.3668 27.1953 26.6332 26.4142 27.4142C25.6332 28.1953 24.3668 28.1953 23.5858 27.4142L18.5858 22.4142C18.2107 22.0391 18 21.5304 18 21V11C18 9.89543 18.8954 9 20 9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)

export const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m382-354 339-339q12-12 28-12t28 12q12 12 12 28.5T777-636L410-268q-12 12-28 12t-28-12L182-440q-12-12-11.5-28.5T183-497q12-12 28.5-12t28.5 12l142 143Z" />
  </svg>
)

export const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="20"
    viewBox="0 0 24 24"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
      fillRule="evenodd"
    ></path>
  </svg>
)

export const ChevronDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 14.975C11.8667 14.975 11.7417 14.9542 11.625 14.9125C11.5083 14.8708 11.4 14.8 11.3 14.7L6.7 10.1C6.51667 9.91667 6.425 9.68334 6.425 9.4C6.425 9.11667 6.51667 8.88334 6.7 8.7C6.88334 8.51667 7.11667 8.425 7.4 8.425C7.68334 8.425 7.91667 8.51667 8.1 8.7L12 12.6L15.9 8.7C16.0833 8.51667 16.3167 8.425 16.6 8.425C16.8833 8.425 17.1167 8.51667 17.3 8.7C17.4833 8.88334 17.575 9.11667 17.575 9.4C17.575 9.68334 17.4833 9.91667 17.3 10.1L12.7 14.7C12.6 14.8 12.4917 14.8708 12.375 14.9125C12.2583 14.9542 12.1333 14.975 12 14.975Z"
      fill="currentColor"
    />
  </svg>
)

export const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.77778 16.0081V9.00806H0V7.00806H5.33333V9.00806H3.55556V16.0081H1.77778ZM1.77778 5.00806V0.00805664H3.55556V5.00806H1.77778ZM5.33333 5.00806V3.00806H7.11111V0.00805664H8.88889V3.00806H10.6667V5.00806H5.33333ZM7.11111 16.0081V7.00806H8.88889V16.0081H7.11111ZM12.4444 16.0081V13.0081H10.6667V11.0081H16V13.0081H14.2222V16.0081H12.4444ZM12.4444 9.00806V0.00805664H14.2222V9.00806H12.4444Z"
      fill="currentColor"
    />
  </svg>
)

export const MailIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm640-480L501-453q-5 3-10.5 4.5T480-447q-5 0-10.5-1.5T459-453L160-640v400h640v-400ZM480-520l320-200H160l320 200ZM160-640v10-59 1-32 32-.5 58.5-10 400-400Z" />
  </svg>
)

export const SendIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 -4 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 16V0L19 8L0 16ZM2 13L13.85 8L2 3V6.5L8 8L2 9.5V13Z" />
  </svg>
)

export const SentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="80"
    viewBox="0 0 80 80"
    width="80"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      height="80"
      id="mask0_6073_6462"
      maskUnits="userSpaceOnUse"
      width="80"
      x="0"
      y="0"
    >
      <rect fill="#D9D9D9" height="80" width="80" />
    </mask>
    <g mask="url(#mask0_6073_6462)">
      <path
        d="M36.4171 43.9167L30.3337 37.5834C29.8337 37.0278 29.2226 36.7501 28.5004 36.7501C27.7782 36.7501 27.1393 37.0001 26.5837 37.5001C26.0282 38.0556 25.7504 38.6945 25.7504 39.4167C25.7504 40.139 26.0282 40.7778 26.5837 41.3334L34.6671 49.3334C35.1671 49.8334 35.7504 50.0834 36.4171 50.0834C37.0837 50.0834 37.6671 49.8334 38.1671 49.3334L53.4171 34.1667C53.9171 33.6667 54.1671 33.0556 54.1671 32.3334C54.1671 31.6112 53.8893 31.0001 53.3337 30.5001C52.8337 30.0556 52.2365 29.8473 51.5421 29.8751C50.8476 29.9028 50.2782 30.139 49.8337 30.5834L36.4171 43.9167ZM27.6671 73.0001L22.5004 64.1667L12.1671 62.0834C11.556 61.9723 11.0421 61.639 10.6254 61.0834C10.2087 60.5278 10.056 59.9445 10.1671 59.3334L11.3337 49.3334L4.75041 41.6667C4.30596 41.2223 4.08374 40.6667 4.08374 40.0001C4.08374 39.3334 4.30596 38.7778 4.75041 38.3334L11.3337 30.7501L10.1671 20.7501C10.056 20.139 10.2087 19.5556 10.6254 19.0001C11.0421 18.4445 11.556 18.1112 12.1671 18.0001L22.5004 15.9167L27.6671 7.00006C28.0004 6.44451 28.4726 6.05562 29.0837 5.8334C29.6949 5.61117 30.306 5.63895 30.9171 5.91673L40.0004 10.1667L49.0837 5.91673C49.6949 5.63895 50.306 5.59728 50.9171 5.79173C51.5282 5.98617 52.0004 6.36117 52.3337 6.91673L57.5837 15.9167L67.8337 18.0001C68.4449 18.1112 68.9587 18.4445 69.3754 19.0001C69.7921 19.5556 69.9449 20.139 69.8337 20.7501L68.6671 30.7501L75.2504 38.3334C75.6949 38.7778 75.9171 39.3334 75.9171 40.0001C75.9171 40.6667 75.6949 41.2223 75.2504 41.6667L68.6671 49.3334L69.8337 59.3334C69.9449 59.9445 69.7921 60.5278 69.3754 61.0834C68.9587 61.639 68.4449 61.9723 67.8337 62.0834L57.5837 64.1667L52.3337 73.0834C52.0004 73.639 51.5282 74.014 50.9171 74.2084C50.306 74.4028 49.6949 74.3612 49.0837 74.0834L40.0004 69.8334L30.9171 74.0834C30.306 74.3612 29.6949 74.389 29.0837 74.1667C28.4726 73.9445 28.0004 73.5556 27.6671 73.0001ZM31.0837 68.4167L40.0004 64.6667L49.1671 68.4167L54.7504 60.0834L64.5004 57.5834L63.5004 47.6667L70.2504 40.0001L63.5004 32.1667L64.5004 22.2501L54.7504 19.9167L49.0004 11.5834L40.0004 15.3334L30.8337 11.5834L25.2504 19.9167L15.5004 22.2501L16.5004 32.1667L9.75041 40.0001L16.5004 47.6667L15.5004 57.7501L25.2504 60.0834L31.0837 68.4167Z"
        fill="#30A46C"
      />
    </g>
  </svg>
)

export const PhoneIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z" />
  </svg>
)

export const OrderSummaryIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M160-240v-436L98-810q-7-15-1-30.5t21-22.5q15-7 30.5-1.5T171-844l77 166h464l77-166q7-15 22.5-21t30.5 2q15 7 21 22.5t-1 30.5l-62 134v436q0 33-23.5 56.5T720-160H240q-33 0-56.5-23.5T160-240Zm240-200h160q17 0 28.5-11.5T600-480q0-17-11.5-28.5T560-520H400q-17 0-28.5 11.5T360-480q0 17 11.5 28.5T400-440ZM240-240h480v-358H240v358Zm0 0v-358 358Z" />
  </svg>
)

export const PendingWorkflowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="40"
    viewBox="0 0 40 40"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="4" />
    <path
      clipRule="evenodd"
      d="M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20C10 18.8954 10.8954 18 12 18C13.1046 18 14 18.8954 14 20ZM22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 18.8954 18.8954 18 20 18C21.1046 18 22 18.8954 22 20ZM28 22C29.1046 22 30 21.1046 30 20C30 18.8954 29.1046 18 28 18C26.8954 18 26 18.8954 26 20C26 21.1046 26.8954 22 28 22Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
export const FullScreenIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M200-200h80q17 0 28.5 11.5T320-160q0 17-11.5 28.5T280-120H160q-17 0-28.5-11.5T120-160v-120q0-17 11.5-28.5T160-320q17 0 28.5 11.5T200-280v80Zm560 0v-80q0-17 11.5-28.5T800-320q17 0 28.5 11.5T840-280v120q0 17-11.5 28.5T800-120H680q-17 0-28.5-11.5T640-160q0-17 11.5-28.5T680-200h80ZM200-760v80q0 17-11.5 28.5T160-640q-17 0-28.5-11.5T120-680v-120q0-17 11.5-28.5T160-840h120q17 0 28.5 11.5T320-800q0 17-11.5 28.5T280-760h-80Zm560 0h-80q-17 0-28.5-11.5T640-800q0-17 11.5-28.5T680-840h120q17 0 28.5 11.5T840-800v120q0 17-11.5 28.5T800-640q-17 0-28.5-11.5T760-680v-80Z" />
  </svg>
)

export const ExitFullScreenIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M240-240h-80q-17 0-28.5-11.5T120-280q0-17 11.5-28.5T160-320h120q17 0 28.5 11.5T320-280v120q0 17-11.5 28.5T280-120q-17 0-28.5-11.5T240-160v-80Zm480 0v80q0 17-11.5 28.5T680-120q-17 0-28.5-11.5T640-160v-120q0-17 11.5-28.5T680-320h120q17 0 28.5 11.5T840-280q0 17-11.5 28.5T800-240h-80ZM240-720v-80q0-17 11.5-28.5T280-840q17 0 28.5 11.5T320-800v120q0 17-11.5 28.5T280-640H160q-17 0-28.5-11.5T120-680q0-17 11.5-28.5T160-720h80Zm480 0h80q17 0 28.5 11.5T840-680q0 17-11.5 28.5T800-640H680q-17 0-28.5-11.5T640-680v-120q0-17 11.5-28.5T680-840q17 0 28.5 11.5T720-800v80Z" />
  </svg>
)
